import React, { useState, useEffect } from "react";
import { Button, Typography } from "antd";
import { useSelector } from "react-redux";
import "./Button.less";
//hooks
import { useTranslation } from "react-i18next";

type SaveButtonBarProps = {
  show: boolean;
  onClickSave?: () => void;
};

export default function SaveButtonBar({
  show: propsShow,
  onClickSave: propsOnClickSave,
}: SaveButtonBarProps) {
  const [showbar, setShowBar] = useState(propsShow);
  const { t } = useTranslation(["utils"]);

  let isCollapsed = useSelector((state: any) => state.main.menuIsCollapsed);

  const style = {
    marginLeft: isCollapsed ? "80px" : "256px",
  };

  useEffect(() => {
    setShowBar(propsShow);
    // eslint-disable-next-line
  }, [propsShow]);

  if (showbar) {
    return (
      <>
        <div
          style={{
            width: "calc(100% - " + style.marginLeft + ")",
          }}
          className="SaveButtonBar"
        >
          <div className="SaveButtonBar-container">
            <Typography.Text style={{ marginRight: 24, color: "#fff" }}>
              {t("buttons.unsavedChanges")}
            </Typography.Text>
            <Button
              type="primary"
              size="large"
              onClick={propsOnClickSave}
              style={{ flexGrow: 0 }}
            >
              {t("utils:buttons.save")}
            </Button>
          </div>
        </div>
      </>
    );
  }
  return null;
}
